import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Comment } from 'src/app/core/interfaces/movie.model';
import { MoviesService } from 'src/app/core/services/movies.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent implements OnInit, OnDestroy {
  isBrowser: boolean;

  loading = false;
  reviews: Comment[] = [];

  modalReview: any;
  reviewSelected: Comment;


  constructor(private moviesService: MoviesService, @Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.loadCriticReviews();

    if (this.isBrowser) {
      this.modalReview = $('#modalReview');
    }
  }

  openReview(review: Comment) {
    // this.modalReview = $('#modal');
    this.reviewSelected = review;
    this.modalReview.modal('show');
  }

  loadCriticReviews() {
    this.loading = true;

    this.moviesService.getCriticsReviews().subscribe((res) => {
      this.reviews = res;

      console.log("CRITIS", res);

      res.forEach(comment => {
        comment.commentShort = this.shortComment(comment.comment);
      });

    },
      (error) => {

        console.log("ERROR", error);
      },
      () => this.loading = false
    );

  }

  authorFullName(review: Comment) {
    return review.author.firstName + " " + review.author.lastName || "";
  }

  shortComment(comment: string) {

    let maxLength = 1500;
    let minLength = 500;

    let commentLength = Math.floor((Math.random() * (maxLength + 1 - minLength)) + minLength) + 300;
    // console.log(commentLength, comment.length)

    if (commentLength < comment.length) {
      return comment.substring(0, commentLength) + " ...";
    }

    return comment;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.

    if (this.modalReview) this.modalReview.modal('hide');

  }

  closeReview() {
    this.modalReview.modal('hide');
  }
}
